"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeSlotWrapper = function TimeSlotWrapper(_ref) {
  var children = _ref.children,
      value = _ref.value,
      locale = _ref.locale,
      now = _ref.now,
      top = _ref.top;
  var isLabel = children.props.children && children.props.children.type === 'span';
  var hideLabel = isLabel && (0, _utils.isLabelHidden)(now, value);

  if (hideLabel) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "current-time",
      style: {
        top: top
      }
    }, now.toLocaleString(locale, {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }));
  }

  return children;
};

TimeSlotWrapper.propTypes = {
  top: _propTypes.default.string,
  now: _propTypes.default.instanceOf(Date),
  value: _propTypes.default.instanceOf(Date),
  children: _propTypes.default.shape({
    props: _propTypes.default.shape({
      children: _propTypes.default.node
    })
  }),
  locale: _propTypes.default.string.isRequired
};
TimeSlotWrapper.defaultProps = {
  title: '',
  event: {}
};
var _default = TimeSlotWrapper;
exports.default = _default;